export type WingieHeaderLinks = {
  faq?: string
  contact?: string
  appDownloadLink?: string
  checkReservation?: string
  checkInRedirect?: string
  homePageLinks?: {
    checkIn?: string
    pnrQuery?: string
    cancelRefund?: string
    allAirlines?: string
  }
}

/** API'den gelen tam URL varsa onu kullan, yoksa fallback */
export const resolveApiHref = (apiUrl?: string | null, fallback?: string): string => {
  if (apiUrl && typeof apiUrl === 'string' && apiUrl.trim()) {
    return apiUrl
  }
  return fallback || ''
}

/** host + path veya tam API URL */
export const resolveWingieCardHref = (apiUrl?: string | null, host?: string, path?: string): string => {
  if (apiUrl?.startsWith('http')) {
    return apiUrl
  }
  if (host && path) {
    return `${host}${path}`
  }
  return apiUrl || path || ''
}

const PROMOTED_FLIGHTS_SEARCH_PATTERN = /\/(search|suchen|buscar)\/.*$/i

/** International Sites see-all URL (domain + locale endpoint üzerinden, promoted-flights ile aynı kalıp) */
export const buildInternationalSitesSeeAllUrl = (endpoint?: string | null): string | null => {
  if (!endpoint) return null
  const base = endpoint.replace(/\/$/, '')
  return `${base}/international-sites/`
}

/** Promoted flights kart searchUrl'inden see-all landing URL'i türetir (domain + locale korunur) */
export const buildPromotedFlightsSeeAllUrl = (endpoint?: string | null, sampleSearchUrl?: string | null): string | null => {
  if (sampleSearchUrl?.startsWith('http')) {
    try {
      const url = new URL(sampleSearchUrl)
      const promotedPath = url.pathname.replace(PROMOTED_FLIGHTS_SEARCH_PATTERN, '/promoted-flights/')

      if (promotedPath !== url.pathname) {
        const pathWithTrailingSlash = promotedPath.endsWith('/') ? promotedPath : `${promotedPath}/`
        return `${url.origin}${pathWithTrailingSlash}`
      }
    } catch {
      /* fall through */
    }
  }

  if (!endpoint) return null

  const base = endpoint.replace(/\/$/, '')
  return `${base}/flights/promoted-flights/`
}

export const findFirstPromotedFlightSearchUrl = (promotedFlightsData?: Record<string, unknown> | null): string | null => {
  if (!promotedFlightsData) return null

  const groups = ['international', 'domestic', 'regional', 'christmas', 'visaFree', 'ramadan-holiday-deals'] as const

  for (const key of groups) {
    const flights = promotedFlightsData[key]
    if (!Array.isArray(flights)) continue

    const searchUrl = flights.find((flight) => typeof flight?.searchUrl === 'string' && flight.searchUrl.startsWith('http'))?.searchUrl
    if (searchUrl) return searchUrl
  }

  return null
}
